module.exports = __webpack_public_path__ + "img/2.fdeefe43.jpg";